
export class FlewDefinitionService {
    notifier: any;
    translate?: any;
    transformError?: any;
    transformSuccess?: any;
    success?: any;
/**
 * @param {?=} notifier
 * @param {?=} translate
 * @param {?=} transformError
 * @param {?=} transformSuccess
 * @param {?=} success
 */
constructor(notifier?: any,
                translate?: any,
                transformError?: any,
                transformSuccess?: any,
                success?: any) {
        this.notifier = notifier;
        this.translate = translate;
        this.transformSuccess = transformSuccess;
        this.transformError = transformError;
        this.success = success;
    }
}

function FlewDefinitionService_tsickle_Closure_declarations() {
/** @type {?} */
FlewDefinitionService.prototype.notifier;
/** @type {?} */
FlewDefinitionService.prototype.translate;
/** @type {?} */
FlewDefinitionService.prototype.transformError;
/** @type {?} */
FlewDefinitionService.prototype.transformSuccess;
/** @type {?} */
FlewDefinitionService.prototype.success;
}


